import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';

import TextField from 'components/ui/TextField';
import Button from 'components/ui/Button';
import DatePicker from 'components/ui/DatePicker';
import { SearchTransactions } from 'functions/kassa24';
import { setIsSearchTransactionByAccount } from 'features/mainSlice';

import ServicesSelect from './servicesSelect';
import { exportReport } from 'functions/helpers';

const PAYMENT_STATUSES = [
  { value: '', label: 'Все' },
  { value: '0', label: 'Проведенные' },
  { value: '2', label: 'Не проведенные' },
  { value: '1', label: 'Помеченные на отмену' },
];

const SearchTransaction = () => {
  const dispatch = useDispatch();
  const transParams = useSelector((state) => state.main.transParams);
  const params = { ...transParams };
  const [paramTerminal, setParamTerminal] = useState(params.Terminal || '');
  const [paramTrans, setParamTrans] = useState(params.Transaction);
  const [paramNumber, setParamNumber] = useState(params.Number);
  const [paramCount, setParamCount] = useState(params.Limit);
  const transListAP = useSelector((state) => state.main.transListAP);
  const transListLK = useSelector((state) => state.main.transListLK);
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(3, 'days').format('YYYY-MM-DD 00:00:00'))
  );
  const [dateTo, setDateTo] = useState(new Date());
  const [status, setStatus] = useState(params.Status);
  const [service, setService] = useState(params.Service);
  const hasResult = transListAP.length > 0 || transListLK.length > 0;

  // поиск транзакций
  const searchTrans = () => {
    let data = params;
    data.Terminal = Number(paramTerminal);
    data.Number = paramNumber.trim();
    data.Transaction = paramTrans.trim();
    data.Limit = paramCount;
    data.Date_from = moment(dateFrom).format('YYYY-MM-DD HH:mm:ss');
    data.Date_to = moment(dateTo).format('YYYY-MM-DD HH:mm:ss');
    data.Status = status;
    data.Service = Number(service);

    SearchTransactions(false, [{ ...data, IDPayments: '' }], true, dispatch);
    if (paramNumber > 0) {
      dispatch(setIsSearchTransactionByAccount(true));
    } else {
      dispatch(setIsSearchTransactionByAccount(false));
    }
  };

  const FORM_FIELDS = [
    {
      value: paramNumber,
      label: 'Номер счета',
      onInput: setParamNumber,
      type: 'text',
      name: 'Number',
    },
    {
      value: paramTrans,
      label: 'Транзакция',
      onInput: setParamTrans,
      type: 'text',
      name: 'Transaction',
    },
    {
      label: '',
      value: dateFrom,
      onInput: setDateFrom,
      type: 'date',
      name: 'dateFrom',
    },
    {
      label: '',
      value: dateTo,
      onInput: setDateTo,
      type: 'date',
      name: 'dateTo',
    },
    {
      value: paramTerminal,
      label: 'Терминал',
      onInput: setParamTerminal,
      type: 'text',
      name: 'Terminal',
    },
    {
      value: paramCount,
      label: 'Количество',
      onInput: setParamCount,
      type: 'number',
      name: 'Limit',
    },
  ];

  const handleExportClick = () => {
    if (transListAP.length > 0) {
      exportReport(transListAP, 'kassa24ApTransactions');
      return;
    }

    if (transListLK.length > 0) {
      exportReport(transListLK, 'kassa24LKTransactions');
    }
  };

  return (
    <>
      <ServicesSelect setData={setService} />
      <div className="formFields">
        {FORM_FIELDS.map((item) => (
          <div key={item.name}>
            {item.type === 'date' ? (
              <DatePicker selected={item.value} onChange={item.onInput} />
            ) : (
              <TextField
                value={item.value}
                name={item.name}
                onChange={(e) =>
                  item.onInput(
                    item.type === 'number'
                      ? Number(e.target.value)
                      : e.target.value
                  )
                }
                label={item.label}
                type={item.type}
                fullWidth
                variant="filled"
              />
            )}
          </div>
        ))}

        <div className="customSelect">
          <FormControl variant="filled">
            <InputLabel id="demo-simple-select-outlined-label">
              Статус платежа
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              variant="filled"
              value={status}
              type="select"
              label="Статус платежа"
              onChange={(e) => setStatus(e.target.value)}
            >
              {PAYMENT_STATUSES.map((option) => {
                return (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>

        <div className="kassa24SearchButtons">
          <Button
            color="primary"
            onClick={searchTrans}
            className="noVerticalMarg fullWidth"
          >
            Найти
          </Button>
          <Button
            color="primary"
            onClick={handleExportClick}
            className="noVerticalMarg fullWidth"
            disabled={!hasResult}
          >
            Экспорт в Excel
          </Button>
        </div>
      </div>
    </>
  );
};

export default SearchTransaction;
